// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Types__Time = require("../../../reason/common/types/Types__Time.bs.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelayValidatorsShowings_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowings_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.bs.js");
var PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.bs.js");
var PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.bs.js");
var PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.bs.js");
var PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.bs.js");

var convertFragment = PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.node, convertFragment, fRef);
}

var ShowingFragment_showingTypeV5_decode = PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.Utils.showingTypeV5_decode;

var ShowingFragment_showingTypeV5_fromString = PropertyWizardFormRelayValidatorsShowingsShowingType_showing_graphql.Utils.showingTypeV5_fromString;

var ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function validate(date) {
  if (date !== undefined) {
    return "Valid";
  } else {
    return {
            NAME: "Error",
            VAL: "is required"
          };
  }
}

function useIsValid(showing) {
  var showing$1 = use(showing);
  return validate(showing$1.type_);
}

var Type = {
  ShowingFragment: ShowingFragment,
  validate: validate,
  useIsValid: useIsValid
};

var convertFragment$1 = PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingDate_draft_graphql.node, convertFragment$1, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertFragment$2 = PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingDate_showing_graphql.node, convertFragment$2, fRef);
}

var ShowingFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function validate$1(date, id, timeZone) {
  if (date === undefined) {
    return {
            NAME: "Error",
            VAL: "is required"
          };
  }
  if (id !== undefined) {
    return "Valid";
  }
  var date$1 = Caml_option.valFromOption(date);
  if (DateFns.isSameDay(CalendarDate.toLocalDate(date$1), CalendarDate.toLocalDate(CalendarDate.today(DateFnsTz.Timezone.make(timeZone)))) || DateFns.isAfter(CalendarDate.toLocalDate(date$1), CalendarDate.toLocalDate(CalendarDate.today(DateFnsTz.Timezone.make(timeZone))))) {
    return "Valid";
  } else {
    return {
            NAME: "Error",
            VAL: "must be after today"
          };
  }
}

function useIsValid$1(showing, draft) {
  var showing$1 = use$2(showing);
  var draft$1 = use$1(draft);
  return validate$1(showing$1.date, showing$1.id, draft$1.timeZone);
}

var $$Date = {
  DraftFragment: DraftFragment,
  ShowingFragment: ShowingFragment$1,
  validate: validate$1,
  useIsValid: useIsValid$1
};

var convertFragment$3 = PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingStartTime_showing_graphql.node, convertFragment$3, fRef);
}

var ShowingFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function validate$2(startTime) {
  if (startTime !== undefined) {
    return "Valid";
  } else {
    return {
            NAME: "Error",
            VAL: "is required"
          };
  }
}

function useIsValid$2(showing) {
  var showing$1 = use$3(showing);
  return validate$2(showing$1.startTime);
}

var StartTime = {
  ShowingFragment: ShowingFragment$2,
  validate: validate$2,
  useIsValid: useIsValid$2
};

var convertFragment$4 = PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowingEndTime_showing_graphql.node, convertFragment$4, fRef);
}

var ShowingFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function validate$3(endTime, startTime) {
  if (endTime === undefined) {
    return {
            NAME: "Error",
            VAL: "is required"
          };
  }
  if (startTime === undefined) {
    return ;
  }
  var match = Types__Time.decode(endTime);
  var match$1 = Types__Time.decode(startTime);
  if (match.TAG === "Ok" && match$1.TAG === "Ok") {
    if (Types__Time.cmp(match._0, match$1._0) >= 0) {
      return "Valid";
    } else {
      return {
              NAME: "Error",
              VAL: "must be after start time"
            };
    }
  } else {
    return {
            NAME: "Error",
            VAL: "time malformed"
          };
  }
}

function useIsValid$3(showing) {
  var showing$1 = use$4(showing);
  return validate$3(showing$1.endTime, showing$1.startTime);
}

var EndTime = {
  ShowingFragment: ShowingFragment$3,
  validate: validate$3,
  useIsValid: useIsValid$3
};

function validate$4() {
  return "Valid";
}

function useIsValid$4() {
  return "Valid";
}

var Notes = {
  validate: validate$4,
  useIsValid: useIsValid$4
};

var convertFragment$5 = PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.node, convertFragment$5, fRef);
}

var ShowingsFragment_showingTypeV5_decode = PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.Utils.showingTypeV5_decode;

var ShowingsFragment_showingTypeV5_fromString = PropertyWizardFormRelayValidatorsShowingsShowings_showing_graphql.Utils.showingTypeV5_fromString;

var ShowingsFragment = {
  showingTypeV5_decode: ShowingsFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingsFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function validate$5(showing, timeZone) {
  return PropertyWizardRelayUtils.FormUtils.allValid([
              validate(showing.type_),
              validate$1(showing.date, showing.id, timeZone),
              validate$3(showing.endTime, showing.startTime),
              validate$2(showing.startTime)
            ]);
}

var Showing = {
  Type: Type,
  $$Date: $$Date,
  StartTime: StartTime,
  EndTime: EndTime,
  Notes: Notes,
  ShowingsFragment: ShowingsFragment,
  validate: validate$5
};

var convertFragment$6 = PropertyWizardFormRelayValidatorsShowings_draft_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsShowings_draft_graphql.node, convertFragment$6, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayValidatorsShowings_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayValidatorsShowings_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment$1 = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

function use$7(draft) {
  var draft$1 = use$6(draft);
  var showings = draft$1.draftProperty.showings.map(function (s) {
        return s.fragmentRefs;
      });
  var showings$1 = use$5(showings);
  var match = draft$1.draftProperty.propertyType;
  if (match === "FOR_SALE") {
    return PropertyWizardRelayUtils.FormUtils.allSubStepsValid(Core__Array.filterMap(showings$1, (function (showing) {
                      if (showing.date === undefined && showing.endTime === undefined && showing.startTime === undefined && showing.type_ === undefined) {
                        return ;
                      }
                      return validate$5(showing, draft$1.timeZone);
                    })));
  } else {
    return "Valid";
  }
}

var FormUtils;

exports.FormUtils = FormUtils;
exports.Showing = Showing;
exports.DraftFragment = DraftFragment$1;
exports.use = use$7;
/* date-fns Not a pure module */
